import React from 'react';
import { createMainController } from '../../../services/createMainController';
import TagSelectPage from '../../../components/TagSelectPage/TagSelectPage';

const TagsSelectorPageController = ({ goToPurpose, skipTagsPage, goBack, t, selectors }) => {
  const tagsSelected = selectors.getSelectedTags();
  return (
    <TagSelectPage
      onNext={goToPurpose}
      onSkip={skipTagsPage}
      onBack={goBack}
      nextButtonText={t('BNG_ON_BOARDING_NEXT_BUTTON')}
      skipButtonText={t('BNG_ON_BOARDING_SKIP_BUTTON')}
      tagsSelected={tagsSelected}
    />
  );
};

export default createMainController(TagsSelectorPageController);
